import { authSplitApi } from 'redux/helpers/slice.helpers';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import {
  TAddTenantFollowUpItemUI,
  TEditTenantFollowUpItemUI,
  TFollowUpItemDB,
  TFollowUpItemUI,
} from 'data/types/tenant.types';
import {
  addTenantFollowUpItemConverter,
  editTenantFollowUpItemConverter,
  tenantFollowUpItemConverter,
} from 'data/converters/tenant.converters';

const URL = `${EPropertyMangerUrl.PROPERTY_MANAGER}/tenant`;

export const tenantApi = authSplitApi('tenantApi', ['followUpItems']).injectEndpoints({
  endpoints: (build) => ({
    getTenantFollowUpItems: build.query<
      TFollowUpItemUI[],
      { tenantId: string; shouldAppendNotificationRelatedItems: boolean; tenantResidencyId: string, animalId?: string }
    >({
      query({ tenantId, shouldAppendNotificationRelatedItems, tenantResidencyId, animalId}) {
        return {
          url: `${URL}/follow-up-item`,
          method: 'GET',
          params: {
            tenantId,
            shouldAppendNotificationRelatedItems,
            tenantResidencyId,
            animalId,
          },
        };
      },
      providesTags: ['tenantFollowUpItems'],
      transformResponse: (data: TFollowUpItemDB[]) => (data || []).map(tenantFollowUpItemConverter.fromDb),
    }),

    addTenantFollowUpItem: build.mutation<void, TAddTenantFollowUpItemUI>({
      query(data) {
        return {
          url: `${URL}/follow-up-item`,
          method: 'POST',
          body: addTenantFollowUpItemConverter.toDb(data),
        };
      },
      invalidatesTags: ['tenantFollowUpItems'],
    }),

    editTenantFollowUpItem: build.mutation<void, TEditTenantFollowUpItemUI>({
      query(data) {
        return {
          url: `${URL}/follow-up-item`,
          method: 'PUT',
          body: editTenantFollowUpItemConverter.toDb(data),
        };
      },
      invalidatesTags: ['tenantFollowUpItems'],
    }),

    deleteTenantFollowUpItem: build.mutation<void, { tenantId: string; tenantFollowUpItemId: string }>({
      query(data) {
        return {
          url: `${URL}/follow-up-item`,
          method: 'DELETE',
          body: data,
        };
      },
      invalidatesTags: ['tenantFollowUpItems'],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetTenantFollowUpItemsQuery,
  useAddTenantFollowUpItemMutation,
  useEditTenantFollowUpItemMutation,
  useDeleteTenantFollowUpItemMutation,
  useLazyGetTenantFollowUpItemsQuery,
} = tenantApi;
